<template>
  <header class="flex py-4">
    <logos />
    <div class="ml-auto md:hidden">
      <survey-percentage :percentage="pagePercent" />
    </div>
  </header>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import Logos from '@/components/Logos'
import SurveyPercentage from '@/components/survey/SurveyPercentage'
const { mapGetters } = createNamespacedHelpers('survey')
export default {
  components: {
    Logos,
    SurveyPercentage
  },
  computed: {
    ...mapGetters(['pagePercent'])
  }
}
</script>
